import React, { Component } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { signout } from '../js/Domain';
import PropTypes from 'prop-types';

/**
 * @description dialog 出場動畫
 */
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * @param {string} scroll 'paper'|'body' // 決定卷軸在 modal 內或外
 */
class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <React.Fragment>
                {this.props.modalOpen ?
                    <Dialog TransitionComponent={Transition} transitionDuration={300}
                        id={this.props.modal.id === undefined ? "confirmModal" : this.props.modal.id}
                        fullWidth={true} maxWidth={this.props.modal.size === undefined ? "md" : this.props.modal.size}
                        scroll={this.props.modal.scroll} data-attribute={this.props.modal.attribute}
                        open={this.props.modalOpen} aria-labelledby="form-dialog-title">
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <DialogTitle>
                                {this.props.modal.modaltitle}
                            </DialogTitle>
                            <Button type="button" disableRipple={true} onClick={this.props.closeClick} style={{ background: "none", color: "#9fa2a5" }}>
                                <Close />
                            </Button>
                        </div>
                        <DialogContent style={{ overflow: "hidden", padding: this.props.modal.padding }} dividers={true}>
                            {this.props.modal.messages}
                            {this.props.modal.field !== undefined ? this.props.modal.field : ""}
                        </DialogContent>
                        <DialogActions>
                            {this.props.modal.modalBtnGroup === undefined ?
                                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                    <Button color="primary" type="button" onClick={this.props.closeClick}>
                                        取消
                                    </Button>
                                    <Button className="MuiOtherButton" color="primary" type="button" onClick={this.props.modal.modalAction}>
                                        確認
                                    </Button>
                                </div> :
                                this.props.modal.modalBtnGroup
                            }
                        </DialogActions>
                    </Dialog>
                    : null
                }
            </React.Fragment>
        );
    }
}

/**
 * Modal
 * @description 型別判斷
 */
Modal.propTypes = {
    dividers: PropTypes.bool,
    fullWidth: PropTypes.bool,
    modalOpen: PropTypes.bool,
    scroll: PropTypes.oneOf(['paper', 'body']),
    close: PropTypes.func,
    maxWidth: PropTypes.string,
    id: PropTypes.string,
    modal: PropTypes.shape({ // 檢查 prop 是否為指定 key 組成的 object
        id: PropTypes.string,
        modaltitle: PropTypes.string,
        modalPosition: PropTypes.string,
        size: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),
        messages: PropTypes.node,
        attribute: PropTypes.string,
        field: PropTypes.element,
        modalAction: PropTypes.func,
    }),
    closeClick: PropTypes.func,
    modalBtnGroup: PropTypes.element,
}

class LoginOutModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: props.modal
        }
    }
    // 登出
    logout = () => {
        // 報表-控制台-即時戰報的版型存下來
        let layoutType_Left = localStorage.getItem("layoutType_Left")
        let layoutType_Right = localStorage.getItem("layoutType_Right")
        this.setState({
            modal: false
        })
        // call api 然後導頁
        signout().then(() => {
            localStorage.setCookie = false;
            sessionStorage.clear();
            localStorage.clear();
            this.props.history.push('/Login');
        }).then(() => {
            // 清完之後再把版型存回 LocalStorage
            localStorage.setItem("layoutType_Left", layoutType_Left)
            localStorage.setItem("layoutType_Right", layoutType_Right)
        });;
    }
    render() {
        return (
            <Dialog open={this.state.modal}>
                <DialogTitle >請重新登入</DialogTitle>
                <DialogContent style={{ overflow: "hidden" }} >
                    <DialogContentText>
                        偵測到此帳號閒置過久，請重新登入
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.logout} color="primary">確認</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export {
    Modal,
    LoginOutModal
};